import React from 'react';
import PropTypes from 'prop-types';

import { FDStack } from '@facet-wealth/design';
import { LozengeLarge } from 'Packages/FacetDesign/Components/Lozenge';

const HouseholdInfoSectionSnippets = ({ collection }) => {
  return (
    <FDStack spacing={1} wrap justifyContent={'flex-end'}>
      {collection.resources().list().map((resource) => {
        // Temporarily use this Lozenge instead of FD, as it handles long values better
        return (
          <LozengeLarge key={resource.id()} value={resource.attr('name')} color={resource.attr('status')} />
        );
      })}
    </FDStack>);
};

HouseholdInfoSectionSnippets.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default HouseholdInfoSectionSnippets;
